import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import employmentContractService from "services/EmploymentContractService";
import { cloneDeep } from "lodash";
// Async thunk to fetch contract types
export const getTypeContract = createAsyncThunk(
  "contractTypes/getTypeContract",
  async (_, { rejectWithValue }) => {
    try {
      const response = await employmentContractService.GetTypeContract();
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const updateContractType = createAsyncThunk(
  "contractTypes/updateContractType",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await employmentContractService.UpdateContractType(data);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);

export const createContractType = createAsyncThunk(
  "contractTypes/createContractType",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await employmentContractService.CreateContractType(data);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);

export const getEcontractTypeSetting = createAsyncThunk(
  "contractTypes/getEcontractTypeSetting",
  async (loaiHopDongId, { rejectWithValue }) => {
    try {
      const res = await employmentContractService.GetEcontractTypeSetting(loaiHopDongId);
      return res.data?.data ?? res.data ?? [];
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const GetDanhSachCotDong = createAsyncThunk(
  "contractTypes/GetDanhSachCotDong",
  async (_, { rejectWithValue }) => {
    try {
      const res = await employmentContractService.GetDanhSachCotDong();
      return res.data?.data ?? res.data ?? [];
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const upsertEcontractTypeSetting = createAsyncThunk(
  "contractTypes/upsertEcontractTypeSetting",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = { ...data };
      delete payload.onSuccess;
      const res = await employmentContractService.UpsertEcontractTypeSetting(payload);
      if (onSuccess) onSuccess(res);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const deleteEcontractTypeSetting = createAsyncThunk(
  "contractTypes/deleteEcontractTypeSetting",
  async ({ id, onSuccess }, { rejectWithValue }) => {
    try {
      const res = await employmentContractService.DeleteEcontractTypeSetting(id);
      if (onSuccess) onSuccess(res);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const deleteContractType = createAsyncThunk(
  "contractTypes/deleteContractType",
  async (data, { rejectWithValue }) => {
    const { onSuccess, id } = data;
    try {
      const response = await employmentContractService.DeleteContractType(id);
      if (onSuccess) onSuccess(response);
      return id;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);


export const importTempContract = createAsyncThunk(
  "contractTypes/importTempContract",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await employmentContractService.importTempContract(payload);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

const initialState = {
  loading: false,
  contractTypeList: [],
  contractTypeListSetting: [],
  econtractTypeSettingList: [],
  danhSachCotDongList: [],
};

const contractTypesSlice = createSlice({
  name: "contractTypes",
  initialState,
  reducers: {

    reseteEcontractTypeSettingList: (state) => {
      state.econtractTypeSettingList = initialState.econtractTypeSettingList;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTypeContract.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTypeContract.fulfilled, (state, action) => {
        state.loading = false;
        state.contractTypeList = action.payload;
        state.contractTypeListSetting = [
          { action: "initial", isRequired: true },
          ...action.payload,
        ];
      })
      //GetDanhSachCotDong
      .addCase(GetDanhSachCotDong.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetDanhSachCotDong.fulfilled, (state, action) => {
        state.loading = false;
        state.danhSachCotDongList = action.payload;
      })
      .addCase(GetDanhSachCotDong.rejected, (state, action) => {
        state.loading = false;
      })
      //
      .addCase(getTypeContract.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(updateContractType.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateContractType.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateContractType.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(createContractType.pending, (state) => {
        state.loading = true;
      })
      .addCase(createContractType.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createContractType.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteContractType.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteContractType.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deleteContractType.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(getEcontractTypeSetting.pending, (state) => { state.loading = true; })
      .addCase(getEcontractTypeSetting.fulfilled, (state, action) => {
        state.loading = false;
        state.econtractTypeSettingList = action.payload;
      })
      .addCase(getEcontractTypeSetting.rejected, (state) => { state.loading = false; })

      .addCase(upsertEcontractTypeSetting.pending, (state) => { state.loading = true; })
      .addCase(upsertEcontractTypeSetting.fulfilled, (state) => { state.loading = false; })
      .addCase(upsertEcontractTypeSetting.rejected, (state) => { state.loading = false; })

      .addCase(deleteEcontractTypeSetting.pending, (state) => { state.loading = true; })
      .addCase(deleteEcontractTypeSetting.fulfilled, (state) => { state.loading = false; })
      .addCase(deleteEcontractTypeSetting.rejected, (state) => { state.loading = false; });
  },
});

export const { reseteEcontractTypeSettingList } = contractTypesSlice.actions;
export default contractTypesSlice.reducer;
